import { Navigate, type RouteObject } from 'react-router';
import { AppShell } from './components/AppShell';
import { LoginPage } from './pages/LoginPage';
import { BookIndexPage } from './pages/book/BookIndexPage';
import { BookPage } from './pages/book/BookPage';
import { ChroniclePage } from './pages/chronicle/ChroniclePage';
import { DigestListPage, DigestPage } from './pages/digest/DigestPages';
import { GoldPage } from './pages/gold/GoldPage';
import { PeoplePage, PersonPage } from './pages/people/PeoplePages';
import { PlaytimePage } from './pages/playtime/PlaytimePage';
import { RecipesPage } from './pages/recipes/RecipesPage';
import { TonightPage } from './pages/tonight/TonightPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { SettingsPage } from './pages/settings/SettingsPage';

/** The map page, in its own chunk with Leaflet (MAP2). */
const mapRoute = () => import('./pages/map/MapPage').then((m) => ({ Component: m.MapPage }));

/** SPEC §9 routes. */
export const routes: RouteObject[] = [
  { path: '/login', element: <LoginPage /> },
  {
    element: <AppShell />,
    children: [
      { path: '/', element: <TonightPage /> },
      { path: '/book', element: <BookIndexPage /> },
      { path: '/book/:id', element: <BookPage /> },
      { path: '/chronicle', element: <ChroniclePage /> },
      { path: '/map', lazy: mapRoute },
      { path: '/map/:slug', lazy: mapRoute },
      // A dungeon's floor (MAP6).
      { path: '/map/:slug/:floor', lazy: mapRoute },
      // The Exploration list became the map's List view.
      { path: '/exploration', element: <Navigate to="/map?view=list" replace /> },
      { path: '/people', element: <PeoplePage /> },
      { path: '/people/:name', element: <PersonPage /> },
      { path: '/playtime', element: <PlaytimePage /> },
      { path: '/gold', element: <GoldPage /> },
      // The Ledger became the Gold page's Overview (M15).
      { path: '/ledger', element: <Navigate to="/gold" replace /> },
      { path: '/recipes', element: <RecipesPage /> },
      { path: '/digest', element: <DigestListPage /> },
      { path: '/digest/:weekId', element: <DigestPage /> },
      { path: '/settings', element: <SettingsPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];
